export enum Role {
  ADMIN = "1a1a1a1a-1a1a-1a1a-1a1a-1a1a1a1a1a1a",
  MANAGER = "2b2b2b2b-2b2b-2b2b-2b2b-2b2b2b2b2b2b",
  CASHIER = "3c3c3c3c-3c3c-3c3c-3c3c-3c3c3c3c3c3c",
  SUPERVISOR = "4d4d4d4d-4d4d-4d4d-4d4d-4d4d4d4d4d4d",
  ACCOUNTANT = "5e5e5e5e-5e5e-5e5e-5e5e-5e5e5e5e5e5e",
  LABOR = "6f6f6f6f-6f6f-6f6f-6f6f-6f6f6f6f6f6f",
}

export const RoleInfo = {
  [Role.ADMIN]: {
    name: "Admin",
    description: "Administrator with full system capabilities",
  },
  [Role.MANAGER]: {
    name: "Manager",
    description: "Store Manager with high-level operational capabilities",
  },
  [Role.CASHIER]: {
    name: "Cashier",
    description: "POS operator with standard checkout capabilities",
  },
  [Role.SUPERVISOR]: {
    name: "Supervisor",
    description: "Operational supervisor",
  },
  [Role.ACCOUNTANT]: {
    name: "Accountant",
    description: "Financial operations manager",
  },
  [Role.LABOR]: {
    name: "Labor",
    description: "General labor role with limited system access",
  },
} as const;

export const getRoleName = (value: Role): string => RoleInfo[value].name;
export const getRoleDescription = (value: Role): string =>
  RoleInfo[value].description;
